import React from 'react';

interface ServersIconProps {
    isActive?: boolean;
}

const ServersIcon: React.FC<ServersIconProps> = ({ isActive = false }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="1.5"
                y="1.5"
                width="13"
                height="4.5"
                rx="1"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <rect
                x="1.5"
                y="10"
                width="13"
                height="4.5"
                rx="1"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <circle cx="4" cy="3.75" r="0.75" fill="currentColor"/>
            <circle cx="4" cy="12.25" r="0.75" fill="currentColor"/>
        </svg>
    );
};

export default ServersIcon;
